/* eslint-disable */
import React from "react";
import { Box, Grid } from "@mui/material";
import { Label12Regular } from "components";

const ProgressBar = ({ data }: any) => {
  const statusData = data?.billStatusCount;

  const statuses = [
    { label: "Warning", color: "#DD1515" },
    { label: "Emissions Included", color: "#9EE766" },
    { label: "Approved (Signed Off)", color: "#0E25D5" },
    { label: "Approved (Locked)", color: "#1D1D1D" },
  ];

  const statusToLabelMap: Record<string, string> = {
    Warning: "Warning",
    "Emissions Included": "Emissions Included",
    "Approved (Signed Off)": "Approved (Signed Off)",
    "Approved (Locked)": "Approved (Locked)",
  };

  const result = Object.keys(statusToLabelMap)?.map((statusKey) => {
    const label = statusToLabelMap[statusKey];
    const statusEntry = statuses?.find((s) => s.label === label);
    const apiEntry = statusData?.find((item: any) => item.status === statusKey);

    return {
      status: statusKey,
      count: apiEntry?.count || 0,
      percentage: apiEntry?.percentage || 0,
      color: statusEntry?.color || "N/A",
      name: statusEntry?.label,
    };
  });

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 350,
        padding: 2,
        border: "1px solid #E0E0E0",
        borderRadius: 2,
        backgroundColor: "#FFFFFF",
      }}
    >
      <Grid container spacing={1}>
        {result.map((status, index) => {
          let leftOffset = 0;
          for (let i = 0; i < index; i++) { // eslint-disable-line
            leftOffset += result[i].percentage;
          }

          return (
            <Grid item xs={12}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer" }}>
                {/* Status Label */}
                <Label12Regular 
                sx={{ 
                  flexShrink: 0, 
                    "@media (min-width: 400px) and (max-width: 899px)": {
                      minWidth: "70%", 
                    },
                    "@media (min-width: 900px) and (max-width: 1200px)": {
                      minWidth: "70%",
                    },
                    "@media (min-width: 1201px) and (max-width: 1600px)": {
                      minWidth: "75%",
                    },
                    "@media (min-width: 1601px) and (max-width: 3000px)": {
                      minWidth: "42%",
                    },
                  color: "#000000", 
                  fontWeight: 500 }}>
                  {status.name}
                </Label12Regular>

                {/* Progress Bar */}
                <Box
                  sx={{
                    height: 14,
                    flexGrow: 1,
                    backgroundColor: "#EAEAEA",
                    borderRadius: 1,
                    position: "relative",
                    minWidth: "20px", // Ensures visibility at small screens
                    maxWidth: "90%"
                  }}
                >
                  <Box
                    sx={{
                      height: "100%",
                      backgroundColor: status.color,
                      width: `${status.percentage}%`,
                      borderRadius: 1,
                      marginLeft: `${leftOffset}%`,
                      minWidth: "0px", // Ensures bar remains visible at small sizes
                    }}
                  />
                </Box>

                {/* Percentage */}
                <span style={{minWidth: "30px", color: "#000000", fontSize: "10px", fontWeight: 600, fontStyle: "Inter", textAlign: "left" }}>
                  {status.percentage}%
                </span>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default ProgressBar;
